import { useNavigate } from 'react-router-dom'

import { ActionItem, BoxList } from '@factorialco/deprecated-design-system'
import find from 'lodash/find'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import DateRange from 'modules/timeoff/components/DateRange'
// TODO: this looks like a bug. This component already has a index.module.css file and it is not being used
import styles from 'modules/timeoff/components/Leaves/LeavesList/Section/Item/index.module.scss'
import {
  leaveIsHourly,
  leaveTotalDaysOrHours,
  leaveUnits,
} from 'modules/timeoff/lib/leaveEmployees'
import type LeaveModel from 'modules/timeoff/store/models/Leave'
import type MedicalLeaveUpdate from 'modules/timeoff/store/models/MedicalLeaveUpdate'

interface Props {
  leave: LeaveModel
  updates: MedicalLeaveUpdate[]
  employeeId: number
  isCurrentEmployee: boolean
  employeeTimeoffPolicyId: number | null | undefined
}

const getYears = (leave: LeaveModel, employeeTimeoffPolicyId: number | null | undefined) => {
  const years = Object.keys(leaveUnits(leave, employeeTimeoffPolicyId) ?? {})
  if (years.length < 2) return years[0]
  const yearEnd = years[years.length - 1]?.slice(2)
  return `${years[0]}/${yearEnd}`
}

const getNumberOfUnits = (
  leave: LeaveModel,
  employeeTimeoffPolicyId: number | null | undefined
) => {
  const total = leaveTotalDaysOrHours(leave, employeeTimeoffPolicyId)
  const copy = leaveIsHourly(leave, employeeTimeoffPolicyId)
    ? i18n.tp('time_off.hours_with_years', {
        count: total,
      })
    : i18n.tp('time_off.days_with_years', {
        count: total,
      })
  return `${copy} (${getYears(leave, employeeTimeoffPolicyId)})`
}

const Item = ({
  leave,
  updates,
  employeeId,
  isCurrentEmployee,
  employeeTimeoffPolicyId,
}: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const title = i18n.t('settings.leave_types.defaults.medical_leave')
  const isLegacyMedical = leave.leaveType?.isMedicalLeave
  const isOpen = !find(updates, (update) => update.isAlta)

  const onClickEdit = () => {
    const myRoute = navigation.timeOff.leavesEditLeaveId.fullPath({ leave_id: leave.attributes.id })
    const anotherRoute = navigation.employees.id.timeOff.leavesEditLeaveId.fullPath({
      id: employeeId,
      leave_id: leave.attributes.id,
    })

    navigate(isCurrentEmployee ? myRoute : anotherRoute)
  }

  const Medical = () => (
    <ActionItem onClick={() => onClickEdit()} showIcon={false}>
      <div className={styles.leave}>
        <DateRange
          leave={leave}
          disabled={isOpen}
          employeeTimeoffPolicyId={employeeTimeoffPolicyId}
        />
        <div className={styles.body}>
          <div className={styles.title} title={title}>
            {title}
          </div>
          <div className={styles.description} title={leave.attributes.description}>
            {getNumberOfUnits(leave, employeeTimeoffPolicyId)}
          </div>
        </div>
      </div>
    </ActionItem>
  )
  if (!isLegacyMedical) return <Medical />
  return (
    <BoxList>
      <Medical />
    </BoxList>
  )
}

export default observer(Item)
